import { ArrowLeft } from "lucide-react"

import TopGlow from "@/assets/img/soulmate/top-glow.png"
import { Button } from "@/components/ui/button"
import type { StepComponentProps } from "./step-contract"

/**
 * Aura palm interstitial (Step25): title + subtitle, then the palm-orbs art
 * edge-to-edge (Figma Palmistry_head is 414×364, no side inset), Continue.
 */
export function AuraPalmIntroStep({ step, onAdvance, onBack }: StepComponentProps) {
  return (
    <div
      className="relative flex h-dvh min-h-dvh flex-col overflow-hidden bg-dark-base text-purple-light"
      data-slot="aura-palm-intro-step"
    >
      <img
        src={TopGlow}
        alt=""
        className="pointer-events-none absolute inset-x-0 top-0 h-[240px] w-full object-cover"
      />

      <div className="relative flex min-h-0 flex-1 flex-col">
        <div className="flex h-14 shrink-0 items-center px-4">
          <button
            type="button"
            onClick={onBack}
            aria-label="Go back"
            className="-ml-2 flex size-10 items-center justify-center rounded-full text-purple-light transition-colors hover:bg-purple-light/10"
          >
            <ArrowLeft className="size-6" />
          </button>
        </div>

        <div className="shrink-0 space-y-2 px-4 text-center">
          <h1 className="font-display text-2xl font-medium text-purple-light">{step.title}</h1>
          {step.subtitle && <p className="text-base text-purple-light/70">{step.subtitle}</p>}
        </div>

        {step.coverImage && (
          <div className="flex min-h-0 flex-1 items-center">
            <img
              src={step.coverImage}
              alt=""
              className="max-h-full w-full object-contain object-bottom"
            />
          </div>
        )}

        <div className="shrink-0 px-4 pt-2 pb-safe">
          <Button variant="gradient" size="xl" onClick={onAdvance}>
            {step.cta ?? "Continue"}
          </Button>
        </div>
      </div>
    </div>
  )
}
